module.exports = __webpack_public_path__ + "img/home.7e2a843.png";